import './PricePod.scss';
import React, { useCallback } from 'react';
import PricePodV1 from './V1/PricePodV1';
import PricePodV2 from './V2/PricePodV2';
import FinanceProposition from '../FinanceProposition';
import { useSelector } from 'react-redux';

const PricePod = ({
	product,
	classes,
	viewModel = {},
	inStock,
	FullTitle,
	Promotions = {},
	Code,
	ColourId,
	State,
	exVat,
}) => {
	const { DeliveryPricingInPricePod } = useSelector(
		(state) => state.featureSwitches
	);

	const pricePodVersion = useCallback(() => {
		if (DeliveryPricingInPricePod) {
			return 2;
		}

		return 1;
	}, [DeliveryPricingInPricePod]);

	const defaultPricePod = () => (
		<>
			<PricePodV1
				classes={classes}
				viewModel={viewModel}
				inStock={inStock}
				FullTitle={FullTitle}
				Promotions={Promotions}
				Code={Code}
				ColourId={ColourId}
				State={State}
			/>
			{product && product?.State !== 'OutOfStock' && (
				<FinanceProposition {...product} />
			)}
		</>
	);

	const deliveryPricingPricePods = () => (
		<>
			<PricePodV2
				classes={classes}
				viewModel={viewModel}
				inStock={inStock}
				FullTitle={FullTitle}
				Promotions={Promotions}
				Code={Code}
				ColourId={ColourId}
				State={State}
				exVat={exVat}
			/>

			{product && product?.State !== 'OutOfStock' && (
				<FinanceProposition {...product} />
			)}
		</>
	);

	switch (pricePodVersion()) {
		case 2:
			return deliveryPricingPricePods();
		default:
			return defaultPricePod();
	}
};

export default PricePod;
